import { Component,Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-valid-code-modal',
  templateUrl: './valid-code-modal.component.html',
  styleUrls: ['./valid-code-modal.component.scss']
})
export class ValidCodeModalComponent {
  constructor (private activeModal: NgbActiveModal)
  { }
  
  @Input() modalText: string | undefined;

  dismissModal()
  {
    this.activeModal.dismiss();
  }

}
